module.exports = __webpack_public_path__ + "static/media/checkmarkIcon.cdfe6e60.svg";